import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "user-area-footer footer",
  "aria-label": "Footer"
}
const _hoisted_2 = {
  "aria-label": "Footer Navigation",
  role: "navigation"
}
const _hoisted_3 = {
  class: "user-area-footer__menu",
  role: "menu"
}
const _hoisted_4 = ["href", "aria-label"]
const _hoisted_5 = {
  key: 0,
  role: "menuitem"
}
const _hoisted_6 = ["aria-label"]

import { computed, ref } from 'vue';
import { useAppStore } from '@/stores/app.store';
import useTranslations from '@/composables/useTranslations';
import LanguageSelector from '@/components/common/languageSelector/LanguageSelector.vue';
import FeedbackDialog from '@/components/common/dialogs/DialogFeedback.vue';
import { FooterLink, layoutAreaTypes } from '@/types/layoutTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAreaFooter',
  setup(__props) {

const appStore = useAppStore();
const { translate: t } = useTranslations();

const feedbackDialogRef = ref();

const systemSettings = computed(() => {
  return appStore.systemSettings;
});
const menuItems = computed<FooterLink[]>(() => [
  {
    href: '/Pages/Overview',
    label: systemSettings.value?.footerMenuViewModel?.manualLabel,
    isVisible: systemSettings.value?.footerMenuViewModel?.isManualVisible,
  },
  {
    href: '/Pages/Accessibility',
    label: systemSettings.value?.footerMenuViewModel?.accessibilityLabel,
    isVisible: systemSettings.value?.footerMenuViewModel?.isAccessibilityVisible,
  },
  {
    href: '/Pages/TermsOfUse',
    label: systemSettings.value?.footerMenuViewModel?.termsOfUseLabel,
    isVisible: systemSettings.value?.footerMenuViewModel?.isTermsOfUseVisible,
  },
  {
    href: '/Pages/Privacy',
    label: systemSettings.value?.footerMenuViewModel?.privacyLabel,
    isVisible: systemSettings.value?.footerMenuViewModel?.isPrivacyVisible,
  },
  {
    href: '/Pages/Imprint',
    label: systemSettings.value?.footerMenuViewModel?.imprintLabel,
    isVisible: systemSettings.value?.footerMenuViewModel?.isImprintVisible,
  },
]);
const visibleMenuItems = computed<FooterLink[]>(() =>
  menuItems.value.filter((menuItem) => menuItem.isVisible),
);

function handleFeedbackBtnClick() {
  feedbackDialogRef.value.openDialog();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createVNode(LanguageSelector, { role: "group" }),
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMenuItems.value, (menuItem) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menuItem.label,
              role: "menuitem"
            }, [
              _createElementVNode("a", {
                class: "user-area-footer__link",
                role: "button",
                tabindex: "0",
                href: menuItem.href,
                "aria-label": `${_unref(t)('Page')} - ${menuItem.label}`
              }, _toDisplayString(menuItem.label), 9, _hoisted_4)
            ]))
          }), 128)),
          (systemSettings.value?.footerMenuViewModel?.isYourFeedbackVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createElementVNode("span", {
                  class: "user-area-footer__link user-area-footer__link--feedback",
                  role: "button",
                  tabindex: "0",
                  "aria-label": `${_unref(t)('Page')} - ${_unref(t)('Page.FeedbackFormLink')}`,
                  onKeyup: _withKeys(handleFeedbackBtnClick, ["enter"]),
                  onClick: handleFeedbackBtnClick
                }, _toDisplayString(_unref(t)('Page.FeedbackFormLink')), 41, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(FeedbackDialog, {
      ref_key: "feedbackDialogRef",
      ref: feedbackDialogRef,
      "layout-area-type": _unref(layoutAreaTypes).User
    }, null, 8, ["layout-area-type"])
  ], 64))
}
}

})